(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__tptcDrawerSplitLinks) return;
  window.__tptcDrawerSplitLinks = true;
  const bound = new WeakSet();
  const bind = () => document.querySelectorAll('header-drawer').forEach(drawer => {
    if (bound.has(drawer)) return;
    bound.add(drawer);
    drawer.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const summary = target?.closest('summary.tptc-drawer-split-summary');
      if (!summary || summary.closest('header-drawer') !== drawer) return;
      if (target.closest('a.tptc-drawer-menu-link')) {
        event.stopPropagation();
        return;
      }
      if (target.closest('.tptc-drawer-submenu-toggle')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const details = summary.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;
        const panel = details.querySelector(':scope > .menu-drawer__submenu');
        if (panel) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
          drawer.open('submenu', event);
        } else {
          details.open = !details.open;
          summary.setAttribute('aria-expanded', String(details.open));
        }
        return;
      }
      if (event.detail === 0) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    drawer.addEventListener('keydown', event => {
      if (event.key !== 'Enter') return;
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest('.tptc-drawer-split-summary a.tptc-drawer-menu-link')) event.stopPropagation();
    }, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once: true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

(() => {
  const bind = () => document.querySelectorAll('header-drawer').forEach(drawer => {
    if (drawer.dataset.tptcSmoothSwipe) return;
    drawer.dataset.tptcSmoothSwipe = 'true';
    let gesture = null;
    const clear = () => {
      if (!gesture) return;
      gesture.panel.style.transition = gesture.transition;
      gesture.panel.style.transform = gesture.transform;
      gesture = null;
    };
    drawer.addEventListener('touchstart', event => {
      if (window.innerWidth >= 990) return;
      event.stopPropagation();
      clear();
      if (event.touches.length !== 1 || !(event.target instanceof Element)) return;
      if (event.target.closest('input,textarea,select,[contenteditable="true"],[role="slider"]')) return;
      const details = drawer.querySelector('#Details-menu-drawer-container[open].menu-open');
      const panel = drawer.querySelector('[ref="menuDrawer"]');
      if (!details || !panel || !panel.contains(event.target)) return;
      for (let node = event.target; node && node !== panel; node = node.parentElement) {
        if (node.scrollWidth > node.clientWidth + 4 && /auto|scroll/.test(getComputedStyle(node).overflowX)) return;
      }
      const t = event.touches[0];
      gesture = {panel,details,id:t.identifier,x:t.clientX,y:t.clientY,time:performance.now(),dx:0,locked:false,transition:panel.style.transition,transform:panel.style.transform};
    }, {passive:true});
    drawer.addEventListener('touchmove', event => {
      if (!gesture) return;
      if (event.touches.length !== 1) { clear(); return; }
      const t = Array.from(event.touches).find(t => t.identifier === gesture.id);
      if (!t) return;
      const dx = t.clientX - gesture.x, dy = t.clientY - gesture.y;
      if (!gesture.locked) {
        if (Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) { clear(); return; }
        if (Math.abs(dx) < 10) return;
        if (dx >= 0 || Math.abs(dx) < Math.abs(dy) * 1.4) { clear(); return; }
        gesture.locked = true;
        gesture.panel.style.transition = 'none';
      }
      if (event.cancelable) event.preventDefault();
      gesture.dx = Math.min(0, Math.max(-gesture.panel.getBoundingClientRect().width, dx));
      gesture.panel.style.transform = `translateX(${gesture.dx}px)`;
    }, {passive:false});
    drawer.addEventListener('touchend', event => {
      if (!gesture) return;
      const g = gesture;
      const t = Array.from(event.changedTouches).find(t => t.identifier === g.id);
      if (!t) return;
      gesture = null;
      if (!g.locked) return;
      const distance = Math.abs(g.dx);
      const duration = Math.max(1, performance.now() - g.time);
      const close = distance > Math.min(110, g.panel.getBoundingClientRect().width * .25) || (distance > 40 && distance / duration > .45);
      g.panel.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1), visibility 260ms ease';
      if (close) {
        const button = g.panel.querySelector('.menu-drawer__close-button');
        if (button) button.click();
        else { clear(); g.panel.style.transform = g.transform; return; }
      }
      requestAnimationFrame(() => { g.panel.style.transform = g.transform; });
      setTimeout(() => { if (!gesture || gesture.panel !== g.panel) g.panel.style.transition = g.transition; }, 300);
      const suppress = e => { e.preventDefault(); e.stopImmediatePropagation(); };
      drawer.addEventListener('click', suppress, true);
      setTimeout(() => drawer.removeEventListener('click', suppress, true), 350);
    }, {passive:true});
    drawer.addEventListener('touchcancel', clear, {passive:true});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tptc-mega-group')) {
    customElements.define('tptc-mega-group', class extends HTMLElement {
      connectedCallback() {
        if (this.toggleHandler) return;
        const toggle = this.querySelector('.tptc-mega-group__toggle');
        const children = this.querySelector('.tptc-mega-group__children');
        if (!toggle || !children) return;
        children.hidden = true;
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
        const submenu = this.closest('.menu-list__submenu');
        const header = this.closest('header-component') || document.querySelector('#header-component');
        this.scheduleResize = () => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (!submenu || !header || !this.isConnected || submenu.inert) return;
            const trigger = submenu.closest('.menu-list__list-item');
            const topLink = trigger?.querySelector(':scope > [aria-expanded], :scope > .menu-list__link-wrapper [aria-expanded]');
            const active = submenu.hasAttribute('data-active') || topLink?.getAttribute('aria-expanded') === 'true';
            if (!active || getComputedStyle(submenu).visibility === 'hidden') return;
            const height = submenu.offsetHeight;
            if (!height) return;
            const visibleHeaderHeight = header.hasAttribute('data-submenu-overlap-bottom-row')
              ? (header.querySelector('.header__row--top')?.offsetHeight || header.offsetHeight)
              : header.offsetHeight;
            const values = {
              '--submenu-height': `${height}px`,
              '--full-open-header-height': `${height + visibleHeaderHeight}px`
            };
            for (const [name, value] of Object.entries(values)) {
              if (header.style.getPropertyValue(name) !== value) header.style.setProperty(name, value);
            }
          });
        };
        this.toggleHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          children.hidden = !expanded;
          this.scheduleResize();
        };
        toggle.addEventListener('click', this.toggleHandler);
        this.sizeObserver = new ResizeObserver(this.scheduleResize);
        this.sizeObserver.observe(this);
        if (submenu) {
          this.stateObserver = new MutationObserver(this.scheduleResize);
          this.stateObserver.observe(submenu, { attributes: true, attributeFilter: ['inert', 'data-active'] });
        }
        window.addEventListener('resize', this.scheduleResize);
        this.scheduleResize();
      }
      disconnectedCallback() {
        this.querySelector('.tptc-mega-group__toggle')?.removeEventListener('click', this.toggleHandler);
        this.sizeObserver?.disconnect();
        this.stateObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleResize);
        cancelAnimationFrame(this.resizeFrame);
        this.toggleHandler = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__tptcHideCardCollections) return;
  window.__tptcHideCardCollections = true;
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  function cleanCard(card) {
    card.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.origin); }
      catch (_) { return; }
      if (url.origin !== location.origin || !/\/collections\/[^/]+\/?$/.test(url.pathname)) return;
      const label = normalize(link.textContent);
      if (!label) return;
      let row = link;
      let parent = link.parentElement;
      while (parent && parent !== card && !parent.classList.contains('product-card__content')) {
        const text = normalize(parent.textContent).replace(/^collection\s*:\s*/i, '');
        if (text !== label || parent.querySelector('img, video, input, button, product-price, .price')) break;
        row = parent;
        parent = parent.parentElement;
      }
      row.setAttribute('data-tptc-card-collection-hidden', '');
      const previous = row.previousSibling;
      if (previous && /^collection\s*:\s*$/i.test(normalize(previous.textContent))) {
        if (previous.nodeType === 1) previous.setAttribute('data-tptc-card-collection-hidden', '');
        else if (previous.nodeType === 3) previous.textContent = '';
      }
    });
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    const enclosingCard = root.closest && root.closest('product-card');
    if (enclosingCard) cleanCard(enclosingCard);
    root.querySelectorAll('product-card').forEach(cleanCard);
  }
  function start() {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') scan(record.target.parentElement);
        else record.addedNodes.forEach(node => scan(node.nodeType === 3 ? node.parentElement : node));
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tptc-fabric-stacked-scroll"] && !Shopify.designMode) return;
  try {
    (() => {
    const marker = document.querySelector('[data-tptc-fabric-stack]');
    const main = document.querySelector('#MainContent');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopScroll = window.matchMedia('(min-width: 990px)');
    if (!marker || !main) return;
    let panels = [];
    let footer = null;
    let observedHeader = null;
    const headerObserver = new ResizeObserver(updateHeaderSpace);
    let scrollElement;
    let scrollTarget;
    let viewportHeight = window.innerHeight;
    let mainTop = 0;
    let frame = 0;
    let rebuildFrame = 0;
    let measureFrame = 0;
    let settleTimer = 0;
    let snapFrame = 0;
    let isSnapping = false;
    let pendingViewportMeasure = false;
    let lastObservedScrollTop = 0;
    let scrollDirection = 1;
    let previousScrollBehavior = '';
    let lastViewportWidth = window.innerWidth;
    const heightProbe = document.createElement('span');
    heightProbe.setAttribute('aria-hidden', 'true');
    heightProbe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100vh;height:100lvh;visibility:hidden;pointer-events:none;contain:strict;';
    document.body.appendChild(heightProbe);
    function updateHeaderSpace() {
      const header = document.querySelector('header-component');
      const height = header ? header.getBoundingClientRect().height : 0;
      const offset = Math.min(Math.max(height, 0), Math.max(viewportHeight - 1, 0));
      main.style.setProperty('--tptc-header-space', `${offset}px`);
    }
    function bindHeaderObserver() {
      const header = document.querySelector('header-component');
      if (header !== observedHeader) {
        headerObserver.disconnect();
        observedHeader = header;
        if (header) headerObserver.observe(header);
      }
      updateHeaderSpace();
    }
    function getTickerHeight() {
      return document.querySelector('tptc-news-ticker')?.getBoundingClientRect().height || 0;
    }
    function getViewportHeight() {
      const height = scrollTarget === document
        ? (window.innerWidth < 750 ? window.innerHeight : (heightProbe.getBoundingClientRect().height || window.innerHeight))
        : scrollElement.clientHeight;
      return Math.max(1, height - getTickerHeight());
    }
    const SETTLE_DELAY = 180;
    const SNAP_DURATION = 900;
    const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);
    function getScrollElement() {
      if (desktopScroll.matches) {
        return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
      }
      return document.scrollingElement || document.documentElement;
    }
    function getScrollTarget(element) {
      return element === document.scrollingElement || element === document.documentElement ? document : element;
    }
    function getScrollTop() {
      return scrollElement?.scrollTop || 0;
    }
    function setScrollTop(top) {
      if (!scrollElement) return;
      scrollElement.scrollTop = top;
    }
    function getPanelTarget(index) {
      const maximumTop = Math.max(0, scrollElement.scrollHeight - scrollElement.clientHeight);
      if (footer && index >= panels.length - 1) return maximumTop;
      return clamp(mainTop + index * viewportHeight, 0, maximumTop);
    }
    function getMainTop() {
      const mainRect = main.getBoundingClientRect();
      if (scrollTarget === document) {
        return getScrollTop() + mainRect.top - getTickerHeight();
      }
      const scrollRect = scrollElement.getBoundingClientRect();
      return getScrollTop() + mainRect.top - scrollRect.top - getTickerHeight();
    }
    function isStackTarget(target, event = null) {
      if (!(target instanceof Element)) return false;
      if (main.contains(target) || footer?.contains(target)) return true;
      if (!event || ![document.body, document.documentElement, scrollElement].includes(target)) return false;
      const pointer = event.touches?.[0] || event;
      if (!Number.isFinite(pointer.clientX) || !Number.isFinite(pointer.clientY)) return false;
      const bounds = scrollTarget === document
        ? { top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight }
        : scrollElement.getBoundingClientRect();
      if (pointer.clientX < bounds.left || pointer.clientX > bounds.right ||
          pointer.clientY < bounds.top || pointer.clientY > bounds.bottom) return false;
      const mainBounds = main.getBoundingClientRect();
      return pointer.clientY >= mainBounds.top && pointer.clientY <= mainBounds.bottom;
    }
    function resetFooter() {
      main.classList.remove('tptc-stack-footer-enabled');
      if (!footer) return;
      footer.classList.remove('tptc-stack-footer-overlay');
      footer.style.removeProperty('--tptc-footer-overlap');
      footer = null;
    }
    function bindFooter() {
      footer = Array.from(main.parentElement.children).find((element) =>
        element.matches('footer, #footer-group, .footer-group') &&
        Boolean(main.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING)
      ) || null;
      if (!footer) return;
      footer.classList.add('tptc-stack-footer-overlay');
      main.classList.add('tptc-stack-footer-enabled');
    }
    function resetSection(section) {
      section.classList.remove('tptc-stack-panel', 'tptc-stack-panel--active', 'tptc-stack-panel--below-header', 'tptc-stack-skip');
      section.classList.remove('tptc-section-edge-fade');
      section.style.removeProperty('--tptc-edge-fade-height');
      section.style.removeProperty('--tptc-stack-z');
      section.style.removeProperty('--tptc-stack-translate');
      section.removeAttribute('inert');
    }
    function findPanels() {
      return Array.from(main.children).filter((section) => {
        if (!(section instanceof HTMLElement) || !section.classList.contains('shopify-section') || section.hidden) {
          return false;
        }
        if (section.querySelector('[data-testid^="divider-"]')) {
          section.classList.add('tptc-stack-skip');
          return false;
        }
        const styles = window.getComputedStyle(section);
        return styles.display !== 'none' && section.getBoundingClientRect().height > 8;
      });
    }
    function bindScrollContainer() {
      scrollTarget?.removeEventListener('scroll', handleScroll);
      scrollElement = getScrollElement();
      scrollTarget = getScrollTarget(scrollElement);
      scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
    }
    function measure(preservedProgress = null) {
      measureFrame = 0;
      if (!panels.length) return;
      viewportHeight = getViewportHeight();
      viewportHeight = Math.max(viewportHeight, 1);
      updateHeaderSpace();
      mainTop = getMainTop();
      main.style.setProperty('--tptc-panel-height', `${viewportHeight}px`);
      main.style.setProperty('--tptc-panel-negative-height', `${-viewportHeight}px`);
      main.style.setProperty('--tptc-stack-height', `${panels.length * viewportHeight}px`);
      footer?.style.setProperty('--tptc-footer-overlap', `${viewportHeight}px`);
      if (Number.isFinite(preservedProgress)) {
        setScrollTop(mainTop + preservedProgress * viewportHeight);
      }
      lastObservedScrollTop = getScrollTop();
      update();
    }
    function updateEdgeFade(panel, progress, height) {
      const fadeHeight = progress > 0 && progress < 1
        ? Math.min(height * 0.18, 160) * Math.min(progress / 0.18, 1)
        : 0;
      panel.classList.toggle('tptc-section-edge-fade', fadeHeight > 0);
      if (fadeHeight > 0) {
        const value = `${fadeHeight.toFixed(2)}px`;
        if (panel.style.getPropertyValue('--tptc-edge-fade-height') !== value) {
          panel.style.setProperty('--tptc-edge-fade-height', value);
        }
      } else {
        panel.style.removeProperty('--tptc-edge-fade-height');
      }
    }
    function update() {
      frame = 0;
      if (reducedMotion.matches) return;
      if (!panels.length) return;
      const localScroll = clamp(getScrollTop() - mainTop, 0, panels.length * viewportHeight);
      const sectionProgress = localScroll / viewportHeight;
      const activeIndex = clamp(Math.floor(sectionProgress), 0, panels.length - 1);
      panels.forEach((panel, index) => {
        const progress = index === panels.length - 1 ? 0 : clamp(sectionProgress - index, 0, 1);
        panel.style.setProperty('--tptc-stack-translate', `${progress * -100}%`);
        updateEdgeFade(panel, progress, viewportHeight);
        panel.classList.toggle('tptc-stack-panel--active', index === activeIndex);
        if (!window.Shopify?.designMode) {
          panel.toggleAttribute('inert', Boolean(footer && sectionProgress >= panels.length - 1) ||
            (index !== activeIndex && index !== activeIndex + 1));
        }
      });
    }
    function requestUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }
    function stopSnap() {
      window.clearTimeout(settleTimer);
      settleTimer = 0;
      if (snapFrame) {
        window.cancelAnimationFrame(snapFrame);
        snapFrame = 0;
      }
      if (isSnapping) {
        if (scrollElement) scrollElement.style.scrollBehavior = previousScrollBehavior;
        isSnapping = false;
        main.classList.remove('tptc-stack-is-snapping');
      }
    }
    function easeInOutCubic(progress) {
      return progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    }
    function animateTo(targetTop, duration = SNAP_DURATION) {
      if (!scrollElement) return;
      stopSnap();
      const startTop = getScrollTop();
      const distance = targetTop - startTop;
      if (Math.abs(distance) < 2) return;
      const startTime = performance.now();
      previousScrollBehavior = scrollElement.style.scrollBehavior;
      scrollElement.style.scrollBehavior = 'auto';
      isSnapping = true;
      main.classList.add('tptc-stack-is-snapping');
      function step(now) {
        if (!isSnapping) {
          return;
        }
        const elapsed = now - startTime;
        const progress = clamp(elapsed / duration, 0, 1);
        setScrollTop(startTop + distance * easeInOutCubic(progress));
        requestUpdate();
        if (progress < 1) {
          snapFrame = window.requestAnimationFrame(step);
          return;
        }
        snapFrame = 0;
        setScrollTop(targetTop);
        scrollElement.style.scrollBehavior = previousScrollBehavior;
        isSnapping = false;
        main.classList.remove('tptc-stack-is-snapping');
        update();
        flushViewportMeasure();
      }
      snapFrame = window.requestAnimationFrame(step);
    }
    function snapToNearestPanel() {
      settleTimer = 0;
      if (
        isSnapping ||
        reducedMotion.matches ||
        panels.length < 2 ||
        document.documentElement.hasAttribute('scroll-lock')
      ) return;
      const localScroll = getScrollTop() - mainTop;
      const lastPanelTop = (panels.length - 1) * viewportHeight;
      if (localScroll < 0 || localScroll > lastPanelTop + 2) return;
      let nearestIndex = clamp(Math.round(localScroll / viewportHeight), 0, panels.length - 1);
      if (footer && nearestIndex === panels.length - 1 && scrollDirection < 0) {
        nearestIndex = Math.max(0, nearestIndex - 1);
      }
      animateTo(getPanelTarget(nearestIndex));
    }
    function scheduleSnap() {
      if (isSnapping || touchGesture || reducedMotion.matches) return;
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(snapToNearestPanel, SETTLE_DELAY);
    }
    function handleScroll() {
      const currentTop = getScrollTop();
      if (Math.abs(currentTop - lastObservedScrollTop) > 1) {
        scrollDirection = Math.sign(currentTop - lastObservedScrollTop);
      }
      lastObservedScrollTop = currentTop;
      requestUpdate();
      scheduleSnap();
    }
    let lastWheelTime = 0;
    let wheelDistance = 0;
    let touchGesture = null;
    function canStep(event, direction) {
      if (!scrollElement || reducedMotion.matches || panels.length < 2 ||
          !main.classList.contains('tptc-fabric-stack') ||
          document.documentElement.hasAttribute('scroll-lock') ||
          document.body.style.position === 'fixed') return false;
      if (!(event.target instanceof Element) || !isStackTarget(event.target, event)) return false;
      if (event.target.closest('input, textarea, select, [contenteditable="true"], dialog[open], [role="dialog"], video[controls]')) return false;
      let node = event.target;
      while (node && node !== main && node !== footer && node !== scrollElement && node !== document.body) {
        const style = getComputedStyle(node);
        if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 2) {
          if ((direction > 0 && node.scrollTop < node.scrollHeight - node.clientHeight - 2) ||
              (direction < 0 && node.scrollTop > 2)) return false;
        }
        node = node.parentElement;
      }
      const local = getScrollTop() - mainTop;
      const lastTop = (panels.length - 1) * viewportHeight;
      return local >= -2 && local <= lastTop + 2 &&
        !(direction < 0 && local <= 2) &&
        !(direction > 0 && local >= lastTop - 2);
    }
    function stepPanel(direction) {
      const local = (getScrollTop() - mainTop) / viewportHeight;
      const index = direction > 0 ? Math.floor(local + 0.01) + 1 : Math.ceil(local - 0.01) - 1;
      animateTo(getPanelTarget(clamp(index, 0, panels.length - 1)));
    }
    function handleWheel(event) {
      if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.deltaY) return;
      const now = performance.now();
      if (now - lastWheelTime > 240 && !isSnapping) {
        wheelDistance = 0;
      }
      const direction = Math.sign(event.deltaY);
      if (isSnapping && isStackTarget(event.target, event)) {
        lastWheelTime = now;
        wheelDistance = 0;
        if (event.cancelable) event.preventDefault();
        return;
      }
      if (!canStep(event, direction) || !event.cancelable) return;
      event.preventDefault();
      lastWheelTime = now;
      window.clearTimeout(settleTimer);
      const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? viewportHeight : 1);
      if (Math.sign(wheelDistance) !== direction) wheelDistance = 0;
      wheelDistance += delta;
      if (Math.abs(wheelDistance) < 35) return;
      wheelDistance = 0;
      stepPanel(direction);
    }
    function handleTouchStart(event) {
      touchGesture = null;
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      touchGesture = { x: touch.clientX, y: touch.clientY, stepped: isSnapping && isStackTarget(event.target, event) };
    }
    function handleTouchMove(event) {
      if (!touchGesture || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dy = touchGesture.y - touch.clientY;
      const dx = touchGesture.x - touch.clientX;
      if (touchGesture.stepped) {
        if (event.cancelable) event.preventDefault();
        return;
      }
      if (Math.abs(dy) < 8 || Math.abs(dx) > Math.abs(dy)) return;
      if (!canStep(event, Math.sign(dy)) || !event.cancelable) {
        touchGesture = null;
        return;
      }
      event.preventDefault();
      window.clearTimeout(settleTimer);
      if (Math.abs(dy) < 40) return;
      touchGesture.stepped = true;
      stepPanel(Math.sign(dy));
    }
    function handleTouchEnd() {
      touchGesture = null;
      flushViewportMeasure();
      if (!isSnapping) scheduleSnap();
    }
    function handleKey(event) {
      const direction = event.key === 'ArrowDown' ? 1 : event.key === 'ArrowUp' ? -1 : 0;
      if (!direction || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey ||
          event.shiftKey || !scrollElement || reducedMotion.matches || panels.length < 2 ||
          !main.classList.contains('tptc-fabric-stack') ||
          document.documentElement.hasAttribute('scroll-lock') ||
          document.body.style.position === 'fixed') return;
      const target = event.target instanceof Element ? event.target : document.activeElement;
      if (target?.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"]), dialog[open], [role="dialog"], [role="menu"], [role="listbox"], [role="slider"], [role="tablist"], video[controls]')) return;
      let node = target;
      while (node && node !== main && node !== scrollElement && node !== document.body) {
        if (node.scrollHeight > node.clientHeight + 2 && /(auto|scroll)/.test(getComputedStyle(node).overflowY)) {
          if ((direction > 0 && node.scrollTop < node.scrollHeight - node.clientHeight - 2) ||
              (direction < 0 && node.scrollTop > 2)) return;
        }
        node = node.parentElement;
      }
      const local = (getScrollTop() - mainTop) / viewportHeight;
      const lastStep = footer ? panels.length - 1 : panels.length;
      if (local < -0.01 || local > lastStep + 0.01 || (direction < 0 && local <= 0.01)) return;
      const nextIndex = direction > 0 ? Math.floor(local + 0.01) + 1 : Math.ceil(local - 0.01) - 1;
      const targetTop = getPanelTarget(clamp(nextIndex, 0, lastStep));
      if (Math.abs(targetTop - getScrollTop()) < 2) return;
      event.preventDefault();
      if (event.repeat || isSnapping) return;
      wheelDistance = 0;
      animateTo(targetTop, 600);
    }
    function bindNavigation(enabled) {
      const action = enabled ? 'addEventListener' : 'removeEventListener';
      window[action]('wheel', handleWheel, { passive: false });
      window[action]('touchstart', handleTouchStart, { passive: true });
      window[action]('touchmove', handleTouchMove, { passive: false });
      window[action]('touchend', handleTouchEnd, { passive: true });
      window[action]('touchcancel', handleTouchEnd, { passive: true });
      window[action]('keydown', handleKey);
    }
    function setup() {
      stopSnap();
      wheelDistance = 0;
      touchGesture = null;
      window.cancelAnimationFrame(measureFrame);
      window.cancelAnimationFrame(frame);
      measureFrame = 0;
      frame = 0;
      bindNavigation(false);
      pendingViewportMeasure = false;
      const hadStack = main.classList.contains('tptc-fabric-stack') && panels.length > 0;
      const preservedProgress = hadStack
        ? clamp((getScrollTop() - mainTop) / Math.max(viewportHeight, 1), 0, panels.length)
        : null;
      bindHeaderObserver();
      const nextPanels = findPanels();
      Array.from(main.children).forEach((section) => {
        resetSection(section);
        if (section.querySelector?.('[data-testid^="divider-"]')) {
          section.classList.add('tptc-stack-skip');
        }
      });
      panels = nextPanels;
      resetFooter();
      if (reducedMotion.matches || panels.length < 2) {
        main.classList.remove('tptc-fabric-stack');
        main.style.removeProperty('--tptc-panel-height');
        main.style.removeProperty('--tptc-panel-negative-height');
        main.style.removeProperty('--tptc-stack-height');
        return;
      }
      main.classList.add('tptc-fabric-stack');
      bindFooter();
      panels.forEach((panel, index) => {
        panel.classList.add('tptc-stack-panel');
        panel.classList.toggle('tptc-stack-panel--below-header', index > 0);
        panel.style.setProperty('--tptc-stack-z', panels.length - index);
      });
      bindScrollContainer();
      bindNavigation(true);
      window.cancelAnimationFrame(measureFrame);
      measureFrame = window.requestAnimationFrame(() => measure(preservedProgress));
    }
    function requestSetup() {
      window.cancelAnimationFrame(rebuildFrame);
      rebuildFrame = window.requestAnimationFrame(setup);
    }
    function flushViewportMeasure() {
      if (pendingViewportMeasure && !isSnapping && !touchGesture) requestMeasure();
    }
    function requestMeasure() {
      if (!panels.length) return;
      // Browser bars can resize the mobile viewport during a swipe. Finish the
      // current transition before resizing panels, preserving section progress.
      if (isSnapping || touchGesture) {
        pendingViewportMeasure = true;
        return;
      }
      pendingViewportMeasure = false;
      stopSnap();
      const preservedProgress = clamp(
        (getScrollTop() - mainTop) / Math.max(viewportHeight, 1),
        0,
        panels.length
      );
      window.cancelAnimationFrame(measureFrame);
      measureFrame = window.requestAnimationFrame(() => measure(preservedProgress));
    }
    function handleResize() {
      const widthChanged = Math.abs(window.innerWidth - lastViewportWidth) > 2;
      lastViewportWidth = window.innerWidth;
      if (widthChanged) {
        requestSetup();
      } else if (scrollElement && Math.abs(getViewportHeight() - viewportHeight) > 2) {
        requestMeasure();
      }
    }
    function scrollToSelectedSection(event) {
      if (
        !window.Shopify?.designMode ||
        reducedMotion.matches ||
        !(event.target instanceof Element) ||
        !scrollElement ||
        panels.length < 2
      ) return;
      const selectedSection = event.target.closest('.shopify-section');
      const index = panels.indexOf(selectedSection);
      if (index < 0) return;
      scrollElement.scrollTo({
        top: mainTop + index * viewportHeight,
        behavior: 'smooth'
      });
    }
    window.addEventListener('tptc:ticker-resize', requestMeasure);
    window.addEventListener('resize', handleResize, { passive: true });
    window.addEventListener('orientationchange', requestSetup, { passive: true });
    window.addEventListener('pageshow', requestSetup);
    desktopScroll.addEventListener('change', requestSetup);
    reducedMotion.addEventListener('change', requestSetup);
    document.addEventListener('shopify:section:load', requestSetup);
    document.addEventListener('shopify:section:unload', requestSetup);
    document.addEventListener('shopify:section:reorder', requestSetup);
    document.addEventListener('shopify:section:select', scrollToSelectedSection);
    setup();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tptc-hero-media-performance"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.tptcHeroMediaPerformance) return;
    window.tptcHeroMediaPerformance = true;
    const videos = new Map();
    let frame = 0;
    function eligible(video, state) {
      if (!state.visible || document.hidden || !video.isConnected) return false;
      const panel = video.closest('.shopify-section');
      return !panel?.classList.contains('tptc-stack-panel') ||
        panel.classList.contains('tptc-stack-panel--active');
    }
    function update() {
      frame = 0;
      videos.forEach((state, video) => {
        if (!eligible(video, state)) {
          if (!video.paused) video.pause();
          return;
        }
        if (!state.loaded) {
          video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
          });
          video.preload = 'auto';
          video.load();
          state.loaded = true;
        }
        if (!video.paused || state.pending || state.failed) return;
        video.muted = true;
        video.playsInline = true;
        state.pending = true;
        Promise.resolve(video.play()).then(() => {
          if (!eligible(video, state)) video.pause();
        }).catch((error) => {
          if (error.name === 'NotAllowedError' || error.name === 'NotSupportedError') {
            state.failed = true;
            video.controls = true;
          }
        }).finally(() => {
          state.pending = false;
        });
      });
    }
    function requestUpdate() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    const visibility = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const state = videos.get(entry.target);
        if (state) state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
      });
      requestUpdate();
    }, { threshold: [0, 0.01], rootMargin: '0px' }) : null;
    function scan() {
      document.querySelectorAll('video[data-tptc-hero-video]').forEach((video) => {
        if (videos.has(video)) return;
        const panel = video.closest('.shopify-section');
        const panelObserver = new MutationObserver(requestUpdate);
        if (panel) panelObserver.observe(panel, { attributes: true, attributeFilter: ['class', 'inert'] });
        videos.set(video, { visible: !visibility, loaded: false, pending: false, failed: false, panelObserver });
        visibility?.observe(video);
      });
      videos.forEach((state, video) => {
        if (video.isConnected) return;
        video.pause();
        visibility?.unobserve(video);
        state.panelObserver.disconnect();
        videos.delete(video);
      });
      requestUpdate();
    }
    function start() {
      scan();
      const observer = new MutationObserver((records) => {
        if (records.some((record) => record.addedNodes.length || record.removedNodes.length)) scan();
      });
      observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', requestUpdate);
    window.addEventListener('pagehide', () => videos.forEach((state, video) => video.pause()));
    window.addEventListener('pageshow', requestUpdate);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tptc-product-breadcrumbs"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__tptcBreadcrumbController) {
    window.__tptcBreadcrumbController.update();
    return;
  }
  const storageKey = 'tptc.visitedPath.v4';
  let memory = [];
  let frame = 0;

  function localURL(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      url.pathname = url.pathname.replace(/\/collections\/[^/]+\/products\//, '/products/');
      url.hash = '';
      if (/\/products\/[^/]+\/?$/.test(url.pathname)) url.search = '';
      else {
        ['section_id', 'sections', 'sections_url'].forEach(key => url.searchParams.delete(key));
      }
      return url;
    } catch (_) { return null; }
  }
  function identity(value) {
    const url = localURL(value);
    if (!url) return null;
    return (url.pathname.replace(/\/collections\/[^/]+\/products\//, '/products/').replace(/\/+$/, '') || '/');
  }
  function cleanTrail(value, home) {
    if (!Array.isArray(value)) return [];
    const clean = [];
    for (const item of value) {
      if (!item || typeof item.url !== 'string' || typeof item.label !== 'string') continue;
      const url = localURL(item.url);
      const id = identity(item.url);
      const label = item.label.trim().slice(0, 160);
      if (!url || !id || id === home || !label) continue;
      const existing = clean.findIndex(page => page.id === id);
      if (existing >= 0) clean.splice(existing);
      clean.push({ id, url: url.pathname + url.search, label });
    }
    return clean.slice(-4);
  }
  function readTrail(home) {
    try { return cleanTrail(JSON.parse(sessionStorage.getItem(storageKey) || '[]'), home); }
    catch (_) { return cleanTrail(memory, home); }
  }
  function saveTrail(trail) {
    memory = trail;
    try { sessionStorage.setItem(storageKey, JSON.stringify(trail)); } catch (_) {}
  }
  function visit(trail, current) {
    const previous = trail.findIndex(item => item.id === current.id);
    if (previous >= 0) return [...trail.slice(0, previous), current].slice(-4);
    return [...trail, current].slice(-4);
  }
  function update() {
    const currentID = identity(location.href);
    const source = Array.from(document.querySelectorAll('[data-tptc-path-tracker]')).find(node => identity(node.dataset.pagePath) === currentID);
    if (!source) return;
    const homeURL = localURL(source.dataset.homeUrl || '/');
    if (!homeURL) return;
    const homeID = identity(homeURL.href);
    const isHome = currentID === homeID;
    const isError = source.dataset.pageType === '404';
    const stored = readTrail(homeID).filter(page => !isError || page.id !== currentID);
    let trail = [];
    if (!isHome) {
      const current = {
        id: currentID,
        url: (() => { const url = localURL(source.dataset.pageUrl || location.href); return url.pathname + url.search; })(),
        label: (source.dataset.pageLabel || document.title).trim().slice(0, 160)
      };
      trail = visit(stored, current);
    }
    saveTrail(isError ? stored : trail);
    let navs = Array.from(document.querySelectorAll('.tptc-product-breadcrumbs'));
    if (!isHome && !navs.length) {
      const nav = document.createElement('nav');
      nav.className = 'tptc-product-breadcrumbs';
      nav.setAttribute('aria-label', source.dataset.navigationLabel || 'Breadcrumbs');
      const list = document.createElement('ol');
      list.className = 'tptc-product-breadcrumbs__list';
      list.setAttribute('role', 'list');
      nav.append(list);
      source.after(nav);
      navs = [nav];
    }
    navs.forEach((nav, navIndex) => {
      nav.hidden = isHome || navIndex > 0;
      if (nav.hidden) return;
      const list = nav.querySelector('.tptc-product-breadcrumbs__list');
      if (!list) return;
      const fragment = document.createDocumentFragment();
      function add(label, href, isCurrent) {
        if (fragment.childNodes.length) {
          const separator = document.createElement('li');
          separator.className = 'tptc-product-breadcrumbs__separator';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = '→';
          fragment.append(separator);
        }
        const li = document.createElement('li');
        if (isCurrent) {
          li.className = 'tptc-product-breadcrumbs__current';
          li.setAttribute('aria-current', 'page');
          li.textContent = label;
        } else {
          const anchor = document.createElement('a');
          anchor.href = href;
          anchor.textContent = label;
          li.append(anchor);
        }
        fragment.append(li);
      }
      add(source.dataset.homeLabel || 'Home', homeURL.pathname + homeURL.search, false);
      trail.forEach((page, index) => add(page.label, page.url, index === trail.length - 1));
      list.replaceChildren(fragment);
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; update(); });
  }
  function navigate(event) {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const anchor = target?.closest('.tptc-product-breadcrumbs a[href]');
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    const url = localURL(anchor.href);
    if (!url) return;
    const source = document.querySelector('[data-tptc-path-tracker]');
    const home = identity(source?.dataset.homeUrl || '/');
    const trail = readTrail(home);
    const targetID = identity(url.href);
    const index = trail.findIndex(item => item.id === targetID);
    if (targetID === home) saveTrail([]);
    else if (index >= 0) saveTrail(trail.slice(0, index + 1));
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }
  window.__tptcBreadcrumbController = { update: schedule };
  window.addEventListener('click', navigate, true);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes' && record.target.matches('[data-tptc-path-tracker]')) { schedule(); return; }
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches('[data-tptc-path-tracker]') || node.querySelector('[data-tptc-path-tracker]'))) { schedule(); return; }
      }
    }
  });
  observer.observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['data-page-path', 'data-page-url', 'data-page-label', 'data-page-type']
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tptc-product-image-hover-zoom"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!document.querySelector('meta[name="tptc-product-hover-zoom"]') || window.tptcCursorZoom) return;
    window.tptcCursorZoom = true;
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    const selector = '#MainContent media-gallery[data-presentation="carousel"] slideshow-slide.product-media-container--image .product-media';
    let host = null;
    let bounds = null;
    let frame = 0;
    let x = 0;
    let y = 0;
    function reset() {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      host?.classList.remove('tptc-hover-zoom-active');
      host = null;
      bounds = null;
    }
    function paint() {
      frame = 0;
      if (!host?.isConnected || !finePointer.matches) { reset(); return; }
      bounds ||= host.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const px = Math.max(0, Math.min(100, (x - bounds.left) / bounds.width * 100));
      const py = Math.max(0, Math.min(100, (y - bounds.top) / bounds.height * 100));
      host.style.setProperty('--tptc-zoom-x', `${px}%`);
      host.style.setProperty('--tptc-zoom-y', `${py}%`);
    }
    document.addEventListener('pointerover', (event) => {
      if (!finePointer.matches || event.pointerType === 'touch' || !(event.target instanceof Element)) return;
      const nextHost = event.target.closest(selector);
      if (!nextHost || nextHost === host || !nextHost.querySelector(':scope > .product-media__image')) return;
      reset();
      host = nextHost;
      x = event.clientX;
      y = event.clientY;
      paint();
      host?.classList.add('tptc-hover-zoom-active');
    }, { passive: true });
    document.addEventListener('pointermove', (event) => {
      if (!host || event.pointerType === 'touch') return;
      x = event.clientX;
      y = event.clientY;
      if (!frame) frame = requestAnimationFrame(paint);
    }, { passive: true });
    document.addEventListener('pointerout', (event) => {
      if (!host || (event.relatedTarget instanceof Node && host.contains(event.relatedTarget))) return;
      if (event.target instanceof Node && host.contains(event.target)) reset();
    }, { passive: true });
    document.addEventListener('scroll', () => { bounds = null; }, { capture: true, passive: true });
    window.addEventListener('resize', () => { bounds = null; }, { passive: true });
    finePointer.addEventListener('change', reset);
    document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tptc-video-viewport"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.tptcViewportVideos || !('IntersectionObserver' in window)) return;
    window.tptcViewportVideos = true;
    const states = new WeakMap();
    const videos = new Set();
    const active = new Set();
    function wantsPlayback(video, state) {
      return state.visible && !document.hidden && video.isConnected && !state.userPaused;
    }
    function restoreSources(video) {
      let changed = false;
      if (!video.getAttribute('src') && video.dataset.src) {
        video.src = video.dataset.src;
        changed = true;
      }
      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (!source.getAttribute('src')) {
          source.src = source.dataset.src;
          changed = true;
        }
      });
      if (changed) video.load();
    }
    function pause(video) {
      const state = states.get(video);
      if (!state) return;
      active.delete(video);
      if (!video.paused) {
        state.automaticPause = true;
        video.pause();
      }
    }
    function play(video) {
      const state = states.get(video);
      if (!state || !wantsPlayback(video, state) || state.pending) return;
      active.add(video);
      if (!video.paused) return;
      video.preload = 'auto';
      restoreSources(video);
      state.pending = true;
      const result = video.play();
      Promise.resolve(result).then(() => {
        if (!wantsPlayback(video, state)) pause(video);
      }).catch(() => {
        active.delete(video);
      }).finally(() => {
        state.pending = false;
      });
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        const state = states.get(video);
        if (!state) return;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
        if (state.visible) play(video);
        else pause(video);
      });
    }, { threshold: [0, 0.1], rootMargin: '0px' });
    function register(video) {
      if (states.has(video) || video.hasAttribute('data-tptc-video-unmanaged')) return;
      const state = { visible: false, pending: false, userPaused: false, automaticPause: false };
      states.set(video, state);
      videos.add(video);
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.muted = true;
      video.defaultMuted = true;
      video.preload = 'none';
      state.onPlay = () => {
        state.userPaused = false;
        if (!state.visible || document.hidden) pause(video);
        else active.add(video);
      };
      state.onPause = () => {
        active.delete(video);
        if (state.automaticPause) state.automaticPause = false;
        else if (video.controls && state.visible && !document.hidden && !video.ended) state.userPaused = true;
      };
      video.addEventListener('play', state.onPlay);
      video.addEventListener('pause', state.onPause);
      pause(video);
      observer.observe(video);
    }
    function scan(root) {
      if (!(root instanceof Element) && root !== document) return;
      if (root instanceof HTMLVideoElement) register(root);
      root.querySelectorAll('video').forEach(register);
    }
    let cleanupFrame = 0;
    function cleanDetached() {
      cleanupFrame = 0;
      videos.forEach((video) => {
        if (video.isConnected) return;
        pause(video);
        observer.unobserve(video);
        const state = states.get(video);
        video.removeEventListener('play', state.onPlay);
        video.removeEventListener('pause', state.onPause);
        states.delete(video);
        videos.delete(video);
      });
    }
    const mutations = new MutationObserver((records) => {
      let removed = false;
      records.forEach((record) => {
        record.addedNodes.forEach(scan);
        if (record.removedNodes.length) removed = true;
      });
      if (removed && !cleanupFrame) cleanupFrame = requestAnimationFrame(cleanDetached);
    });
    function start() {
      scan(document);
      mutations.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) Array.from(active).forEach(pause);
      else videos.forEach((video) => play(video));
    });
    window.addEventListener('pagehide', () => Array.from(active).forEach(pause));
    window.addEventListener('pageshow', () => videos.forEach((video) => play(video)));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-button-custom-styles"] && !Shopify.designMode) return;
  try {
    if (!window.tptcSizeLabelListener) {
    window.tptcSizeLabelListener = true;
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.checked) return;
      const fieldset = input.closest('.tptc-size-option');
      const selected = fieldset?.querySelector('[data-tptc-size-selected]');
      if (selected) selected.textContent = input.value;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!window.tptcSizeLabelListener) {
    window.tptcSizeLabelListener = true;
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.checked) return;
      const fieldset = input.closest('.tptc-size-option');
      const selected = fieldset?.querySelector('[data-tptc-size-selected]');
      if (selected) selected.textContent = input.value;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
